const isDefined = (value: any): boolean =>
  value !== null && value !== undefined;

export default isDefined;
